import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseDatabase } from '@/services/firebase'
import moment from 'moment'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    videos: [],
    showExample: false,
  },
  mutations: {
    setVideos(state, payload) {
      state.videos = payload
    },
    showExample(state) {
      state.showExample = true
    },
    hideExample(state) {
      state.showExample = false
    },
  },
  actions: {
    // read videos when app loads
    async getVideos(context) {
      const videosPayload = []
      await firebaseDatabase.collection('creators')
        .doc('0000000000-example-creator')
        .collection('videos')
        .orderBy('publishDue', 'desc')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              videoID: doc.id,
              data: doc.data(),
              daysFromPublish: Math.round(moment.duration(moment().diff(doc.data().publishDue)).asDays()),
            }
            videosPayload.push(data)
          })
        })
      context.commit('setVideos', videosPayload)
    },
  },
  getters: {
    state: state => state,
  },
}
